import { render } from "./AssemblyVote.vue?vue&type=template&id=6023d3bc&scoped=true"
import script from "./AssemblyVote.vue?vue&type=script&lang=js"
export * from "./AssemblyVote.vue?vue&type=script&lang=js"

import "./AssemblyVote.vue?vue&type=style&index=0&id=6023d3bc&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6023d3bc"]])

export default __exports__